<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
        class="row position-fixed m-0 p-2 background-primary-blue height-70px shadow z-max align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 m-auto">
            <div class="fs-lg text-center color-white">Settings</div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="margin-top-70px flex-grow-1 p-3 overflow-x-hidden overflow-y-auto fix-overflow-scroll no-scroll-bar">
        <div class="mb-3 card overflow-x-hidden p-3">
            <span>Notification token: {{ notificationToken }}</span>
            <hr/>
            <span>App version: {{ environment.appName + ' ' + appVersion }}</span>
        </div>
        <div class="p-1">
            <app-generic-button
                (click)="onToggleAnimals()"
                description="Toggle animal rows"
                [alwaysShowText]="true"
                [buttonClass]="'btn-small'"
                [buttonText]="'Toggle animal rows'"
                [primaryIcon]="'fa-solid fa-cow fa-xl'"
                class="col"/>
        </div>
        <div class="p-1">
            <app-generic-button
                (click)="onToggleKeyValuePairs()"
                description="Toggle key-value pair rows"
                [alwaysShowText]="true"
                [buttonClass]="'btn-small'"
                [buttonText]="'Toggle key pairs rows'"
                [primaryIcon]="'fa-solid fa-list fa-xl'"
                class="col"/>
        </div>
        <div class="p-1">
            <app-generic-button
                (click)="onToggleDeviceAssocations()"
                description="Toggle device associations"
                [alwaysShowText]="true"
                [buttonClass]="'btn-small'"
                [buttonText]="'Toggle device associations'"
                [primaryIcon]="'fa-solid fa-circle-dot fa-xl'"
                class="col"/>
        </div>

        @if (showAnimals) {
            <div class="card overflow-y-auto max-height-vh50 overflow-x-hidden">
                @for (assetRow of assetRows; track assetRow.id) {
                    <div [ngClass]="{'background-light-gray': $index % 2 == 0}"
                        class="row p-4">
                        <div>{{ assetRow.visualTag }}, {{ assetRow.id.substring(30, assetRow.id.length - 1) }}, {{ assetRow.synchronizationStatus }}</div>
                    </div>
                }
            </div>
        }
        @if (showKeyValuePairs) {
            <div class="card overflow-y-auto max-height-vh50 overflow-x-hidden">
                @for (keyValuePair of keyValuePairs; track keyValuePair.id) {
                    <div [ngClass]="{'background-light-gray': $index % 2 == 0}"
                        class="row p-4">
                        <div>{{ keyValuePair?.id }} - {{ keyValuePair?.json }}</div>
                    </div>
                }
            </div>
        }
        @if (showDeviceAssociations) {
            <div>
                <div class="mb-3">
                    <div class="h5">Server Device/Asset Associations:</div>
                    @for (da of deviceAssociations; track da.id) {
                        <div>
                            AssetId: {{ da.assetId }}, DeviceId: {{ da.deviceId }}
                        </div>
                    }
                </div>
                <div class="mb-3">
                    <div class="h5">Local Device/Asset Associations:</div>
                    @for (da of deviceAssociationStore.entities(); track da.id) {
                        <div>
                            AssetId: {{ da.assetId }}, DeviceId: {{ da.deviceId }}
                        </div>
                    }
                </div>
                @if (deviceAssociationStore.entities().length != deviceAssociations.length) {
                    <div class="p-3 card background-warn">
                        There seems to be a mismatch in locally registered device associations and those on the server!
                    </div>
                }
            </div>
        }
    </div>
</div>
